const regionSupportConfig: { [key: string]: boolean } = {
  AU: true,
  CA: true,
  US: true,
};

export function getRegionSupport(country: string) {
  return regionSupportConfig[country] ?? false;
}

export function getRegions(country: string): Array<[string, string]> {
  if (country === 'US') {
    return regionsInUS;
  }

  if (country === 'CA') {
    return regionsInCA;
  }

  if (country === 'AU') {
    return regionsInAU;
  }

  return [];
  // throw `Regions for country "${country}" not found`;
}

/*
 * So far we only support regions in English-speaking countries and those are
 * not used outside of English locale, so for the moment keep them
 * not-translated to reduce the amount of translation terms.
 */

export const regionsInUS: Array<[string, string]> = [
  ['AL', 'Alabama'],
  ['AK', 'Alaska'],
  ['AZ', 'Arizona'],
  ['AR', 'Arkansas'],
  ['CA', 'California'],
  ['CO', 'Colorado'],
  ['CT', 'Connecticut'],
  ['DE', 'Delaware'],
  ['FL', 'Florida'],
  ['GA', 'Georgia'],
  ['HI', 'Hawaii'],
  ['ID', 'Idaho'],
  ['IL', 'Illinois'],
  ['IN', 'Indiana'],
  ['IA', 'Iowa'],
  ['KS', 'Kansas'],
  ['KY', 'Kentucky'],
  ['LA', 'Louisiana'],
  ['ME', 'Maine'],
  ['MD', 'Maryland'],
  ['MA', 'Massachusetts'],
  ['MI', 'Michigan'],
  ['MN', 'Minnesota'],
  ['MS', 'Mississippi'],
  ['MO', 'Missouri'],
  ['MT', 'Montana'],
  ['NE', 'Nebraska'],
  ['NV', 'Nevada'],
  ['NH', 'New Hampshire'],
  ['NJ', 'New Jersey'],
  ['NM', 'New Mexico'],
  ['NY', 'New York'],
  ['NC', 'North Carolina'],
  ['ND', 'North Dakota'],
  ['OH', 'Ohio'],
  ['OK', 'Oklahoma'],
  ['OR', 'Oregon'],
  ['PA', 'Pennsylvania'],
  ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'],
  ['SD', 'South Dakota'],
  ['TN', 'Tennessee'],
  ['TX', 'Texas'],
  ['UT', 'Utah'],
  ['VT', 'Vermont'],
  ['VA', 'Virginia'],
  ['WA', 'Washington'],
  ['WV', 'West Virginia'],
  ['WI', 'Wisconsin'],
  ['WY', 'Wyoming'],
  ['DC', 'District of Columbia'],
  ['AS', 'American Samoa'],
  ['GU', 'Guam'],
  ['MP', 'Northern Mariana Islands'],
  ['PR', 'Puerto rico'],
  ['UM', 'United States Minor Outlying Islands'],
  ['VI', 'U.S. Virgin Islands'],
  ['AA', 'Armed Forces - Americas'],
  ['AE', 'Armed Forces - Europe'],
  ['AP', 'Armed Forces - Pacific'],
];

export const regionsInCA: Array<[string, string]> = [
  ['AB', 'Alberta'],
  ['BC', 'British Columbia'],
  ['MB', 'Manitoba'],
  ['NB', 'New Brunswick'],
  ['NL', 'Newfoundland and Labrador'],
  ['NS', 'Nova Scotia'],
  ['NT', 'Northwest Territories'],
  ['NU', 'Nunavut'],
  ['ON', 'Ontario'],
  ['PE', 'Prince Edward Island'],
  ['QC', 'Quebec'],
  ['SK', 'Saskatchewan'],
  ['YT', 'Yukon'],
];

export const regionsInAU: Array<[string, string]> = [
  ['ACT', 'Australian Capital Territory'],
  ['NSW', 'New South Wales'],
  ['NT', 'Northern Territory'],
  ['QLD', 'Queensland'],
  ['SA', 'South Australia'],
  ['TAS', 'Tasmania'],
  ['VIC', 'Victoria'],
  ['WA', 'Western Australia'],
];
